<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">日本经营管理签证</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>
        2006年，日本入国管理局为欢迎在日本创业定居的人士设立了投资经营签证。为吸引更多的外国经营管理人才定居日本，增强日本经济活力，日本参院全体会议于2014年6月11日通过《入管法改正案》，在2015年4月1日开始正式实施《入境管理难民法改正案》。其中一项就是将[投经营签证]变更为[经营管理签证]，自此更加着重申请人在公司中所发挥的经营和管理才能。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/jp/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <h5>申请人：</h5>
            <p>年满20周岁</p>
            <h5>公司：</h5>
            <p>
              a) 以公司名义持有房产<br/>
              b) 注册资本金500万日本<br/>
              c) 有注册地址、实际办公室<br/>
              d) 有公司账户
            </p>


          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/jp/2.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、永久产权</p>
            <p>2、可购买土地</p>
            <p>3、可联名/公司/个人购买</p>
            <p>4、无公摊，阳台赠送</p>
            <p>5、精装交付，无需配备家具家电</p>
            <p>6、法律完善，价格透明</p>
            <p>7、租赁市场稳定</p>
            <p>8、无资产来源要求及背景调查</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/jp/4.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、付定金并签订合作协议</p>
            <p>2、准备公司注册材料</p>
            <p>3、完成公司注册，及税务开业申报、银行开户</p>
            <p>4、准备签证申请材料并想入管局提交申请</p>
            <p>5、通过申请，发放相关证明</p>
            <p>6、入境获得日本签证</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
export default {
  name: 'Jp'
}
</script>

<style scoped>

</style>
